import {
  Component,
  Input,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SampleUtilsService } from '@app/modules/service-data/services/sample-utils.service';
import { GetSamplesListAction } from '@app/modules/service-data/store/sample.actions';
import { SampleState } from '@app/modules/service-data/store/sample.state';
import { Sample } from '@app/modules/service-data/types/sample.types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableActionType,
  DataTableActionsLocation,
  DataTableConfiguration,
  DataTableDataType,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import { Observable, map, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-sample-results',
  imports: [TranslateModule, DataTableComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './sample-results.component.html',
})
export class SampleResultsComponent implements OnInit {
  private dialogRef = inject(NgbActiveModal);
  private sampleUtilsService = inject(SampleUtilsService);
  private store = inject(Store);
  private translateService = inject(TranslateService);

  @Input() public sampleIds: string[];

  protected dataTableConfiguration: DataTableConfiguration;
  protected isLoading = true;

  private rows$: Observable<Sample[]>;

  ngOnInit(): void {
    this.rows$ = this.store
      .dispatch(
        new GetSamplesListAction({ ids: this.sampleIds }, {}, null, false)
      )
      .pipe(
        switchMap(() =>
          this.store.select(SampleState.getSamplesByIds).pipe(
            map((getSamplesByIds) => getSamplesByIds(this.sampleIds)),
            tap(() => (this.isLoading = false))
          )
        )
      );

    this.dataTableConfiguration = {
      title: '',
      selectionMode: DataTableSelectionType.NONE,
      actionsLocation: DataTableActionsLocation.RIGHT,
      tableHeadClasses: '',
      actionsClasses: 'text-end',
      columns: [
        {
          label: 'sample.search.resultsTable.columns.barcode',
          property: 'kitId',
        },
        {
          label: 'sample.search.resultsTable.columns.dateOfVenipuncture',
          property: 'dateOfVenipuncture',
          type: DataTableDataType.DATETIME,
        },
        {
          label: 'sample.search.resultsTable.columns.waybill',
          property: 'shippingInformation.waybill',
        },
      ],
      singleActions: [
        {
          name: 'sample.search.resultsTable.actions.openDetails',
          icon: 'fa-light fa-file',
          type: DataTableActionType.BUTTON,
          action: this.openSampleDetails.bind(this),
        },
      ],
      rows$: this.rows$,
    };
  }

  private openSampleDetails(event: MouseEvent, sample: Sample) {
    this.sampleUtilsService.openDetails(sample.id);
    this.dismiss();
  }

  dismiss() {
    this.dialogRef.close();
  }
}
